import { render, staticRenderFns } from "./RateRequestsLayout.vue?vue&type=template&id=a2cdaea2&"
import script from "./RateRequestsLayout.vue?vue&type=script&lang=js&"
export * from "./RateRequestsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports